import ToolsPage from './ToolsPage';

export default ToolsPage;
